import { apiClient } from "../config";
async function getBrandDetailsByBrandCode(brandCode: any) {
    const res = await apiClient.get(`/admin/brands/${brandCode}/detail`);
    return res.data;
}
export default getBrandDetailsByBrandCode;